import { Card } from '@mantine/core'

import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'
import BasicTemplate from 'src/v2/commons/templates/BasicTemplate'

import UserInformation from '../components/UserInformation/UserInformation.component'
import { useCreateUser } from '../hooks/useCreateUser.hook'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Administration Panel' },
  { title: 'Users' },
  { title: 'Create New User' },
]

const CreateUserView = () => {
  const { userCreateForm, handleCancelForm, onSubmit, loading } =
    useCreateUser()

  return (
    <BasicTemplate
      isLoading={false}
      title="Users"
      breadCrumbItems={breadCrumbItems}
    >
      <Card shadow="lg" radius="sm">
        <UserInformation
          loading={loading}
          onSubmit={onSubmit}
          userInformationForm={userCreateForm}
          editForm={true}
          setEditForm={() => null}
          handleCancelForm={handleCancelForm}
          isCreateNew={true}
        />
      </Card>
    </BasicTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  CreateUserView,
  'is_get_roles_enabled',
  true,
)
